import { apiBaseUrl } from '../../backend/config.js'; 
import { getAuthToken } from './auth.js';
import { t, confirmT, updateElementText } from './translationHelper.js';
import translations from './translations.js';
globalThis.ZTranslations = globalThis.ZTranslations || translations;

function _get(obj, pathArr) {
  return pathArr.reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), obj);
}

function T(key, fallback = '') {
  try {
	const res = t(key, null);
	if (typeof res === 'string' && res && res !== key) return res;
  } catch (_) {}

  const lang =
	(globalThis.Z_LANG || globalThis.Z_LOCALE || localStorage.getItem('language') || localStorage.getItem('locale') || (navigator.language || '').slice(0, 2) || 'en');

  const dict = translations?.[lang] || translations?.fr || translations?.en || null;
  if (dict) {
	const val = _get(dict, key.split('.'));
	if (typeof val === 'string' && val) return val;
  }

  return fallback || key;
}

const tx = (k, fb) => T(`tax.${k}`, fb);

// Qualitative descriptor function for Zollars (users see descriptions, not numbers)
function getQualitativeDescriptor(quantity, max) {
  const q = Number(quantity) || 0;
  const m = Number(max);
  if (q <= 0) return 'None';
  if (m && m > 0) {
    const r = q / m;
    if (r <= 0.01)  return 'None';
    if (r <= 0.03)  return 'Barely Any';
    if (r <= 0.07)  return 'A Trace';
    if (r <= 0.12)  return 'A Hint';
    if (r <= 0.18)  return 'A Little';
    if (r <= 0.26)  return 'A Few';
    if (r <= 0.33)  return 'Some';
    if (r <= 0.40)  return 'Several';
    if (r <= 0.50)  return 'Moderate';
    if (r <= 0.58)  return 'Noticeable';
    if (r <= 0.65)  return 'Considerable';
    if (r <= 0.72)  return 'Many';
    if (r <= 0.78)  return 'A Lot';
    if (r <= 0.83)  return 'Abundant';
    if (r <= 0.88)  return 'Heaps';
    if (r <= 0.92)  return 'A Great Deal';
    if (r <= 0.95)  return 'Almost All';
    if (r <= 0.97)  return 'Nearly Everything';
    if (r <= 0.985) return 'Overflowing';
    if (r <= 0.995) return 'Virtually Everything';
    return 'All You Have';
  }

  if (q <= 0)   return 'None';
  if (q <= 1)   return 'Barely Any';
  if (q <= 2)   return 'A Trace';
  if (q <= 3)   return 'A Hint';
  if (q <= 4)   return 'A Little';
  if (q <= 6)   return 'A Few';
  if (q <= 9)   return 'Some';
  if (q <= 12)  return 'Several';
  if (q <= 16)  return 'Moderate';
  if (q <= 20)  return 'Noticeable';
  if (q <= 26)  return 'Considerable';
  if (q <= 33)  return 'Many';
  if (q <= 40)  return 'A Lot';
  if (q <= 55)  return 'Abundant';
  if (q <= 70)  return 'Heaps';
  if (q <= 90)  return 'A Great Deal';
  if (q <= 120) return 'Substantial';
  if (q <= 160) return 'Ample';
  if (q <= 210) return 'Extensive';
  if (q <= 260) return 'Vast';
  if (q <= 320) return 'Profuse';
  if (q <= 380) return 'Almost All';
  if (q <= 440) return 'Nearly Everything';
  if (q <= 490) return 'Virtually Everything';
  return 'All You Have';
}

let taxEventInProgress = false;

export function showTaxDecisionPopup(userId, pointAmount, zollarAmount) {
  console.log('showTaxDecisionPopup called with userId:', userId, 'pointAmount:', pointAmount, 'zollarAmount:', zollarAmount);
  if (taxEventInProgress) {
	return;
  }
  taxEventInProgress = true;
  showTaxPrompt(userId, pointAmount, zollarAmount);
}

// Function to directly proceed with points deduction if no items are available
function directlyProceedWithPointsDecision(userId) {
  const userWantsToGiveItem = confirm(
	t('tax.tax_call_no_assets', 'Zederal Reserve has issued a tax call. Press OK to lose capital, no assets available for payment.')
  );
  if (!userWantsToGiveItem) {
	submitUserDecision(userId, 'points', null);
  }
}

export function showTaxPrompt(userId, pointAmount, zollarAmount) {
  console.log('showTaxPrompt called for user:', userId);
  removeExistingTaxModal();
  renderDecisionModal(userId, pointAmount, zollarAmount);
  initiateCountdown(userId, 10, pointAmount, zollarAmount);
}

// Function to render the decision modal
function renderDecisionModal(userId, pointAmount, zollarAmount) {
  console.log('Rendering decision modal for user:', userId, 'with pointAmount:', pointAmount, 'zollarAmount:', zollarAmount);

  // Ensure minimum of 1 zollar if not specified
  const actualZollarAmount = Math.max(1, zollarAmount || 1);

  // Convert zollar amount to qualitative descriptor (users don't see numbers for Zollars)
  const zollarDescriptor = getQualitativeDescriptor(actualZollarAmount);

  const decisionModalHTML = `
	<div id="taxDecisionModal" class="tax-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.8); display: flex; justify-content: center; align-items: center; z-index: 99999;">
	  <div class="tax-modal-content" style="background-color: #000; padding: 20px; border: 2px solid #00ff00; border-radius: 10px; text-align: center; color: #00ff00; max-width: 92vw;">
		<p class="zx-sec-explain" style="text-align:left;max-width:420px;margin:0 auto 10px;">${t('floor.exp_tax', "This is the Zederal Reserve — the market's system player. It taxes every trader from time to time. Choose what to give up before the timer runs out, or it takes both.")}</p>
		<p>${t('tax.tax_alert_timer', 'TAX ALERT! You have 10 seconds to choose or lose both:')}</p>
		<p id="countdown" style="font-size: 24px; font-weight: bold;">10</p>
		<button id="deductPoints" style="margin: 5px; padding: 15px; background-color: #333; color: #00ff00; border: 1px solid #00ff00; min-width: 250px; line-height: 1.5; cursor: pointer;">
		  <div style="font-weight: bold; margin-bottom: 8px; pointer-events: none;">${t('tax.lose_capital_zollars', 'Lose capital & Zollars')}</div>
		  <div style="font-size: 12px; margin-bottom: 3px; pointer-events: none;">${pointAmount} capital</div>
		  <div style="font-size: 12px; pointer-events: none;">${zollarDescriptor} relationship zollars</div>
		</button>
		<button id="giveRandomItem" style="margin: 5px; padding: 10px; background-color: #333; color: #00ff00; border: 1px solid #00ff00; min-width: 250px; cursor: pointer;">
		  <span style="pointer-events: none;">${t('tax.give_random_asset', 'Give random asset')}</span>
		</button>
	  </div>
	</div>
  `;
  document.body.insertAdjacentHTML('beforeend', decisionModalHTML);
  console.log('Decision modal rendered');
}

function initiateCountdown(userId, timeLeft, pointAmount, zollarAmount) {
  console.log('Initiating countdown for user:', userId);
  const startTime = new Date();
  // Ensure minimum of 1 zollar
  const actualZollarAmount = Math.max(1, zollarAmount || 1);
  localStorage.setItem('taxDecisionState', JSON.stringify({ userId, timeLeft, startTime, pointAmount, zollarAmount: actualZollarAmount }));

  const countdownTimer = setInterval(() => {
	const countdownElement = document.getElementById("countdown");
	if (countdownElement) {
	  countdownElement.textContent = Math.max(0, timeLeft);
	}

	if (timeLeft <= 0) {
	  clearInterval(countdownTimer);
	  console.log('Countdown finished, enforcing tax decision');
	  enforceTaxDecision(userId, pointAmount, actualZollarAmount);
	}
	timeLeft--;
  }, 1000);

  document.getElementById('taxDecisionModal').addEventListener('click', (event) => {
	if (event.target.id === 'deductPoints' || event.target.id === 'giveRandomItem') {
	  console.log(`User clicked ${event.target.id}`);
	  handleDecision(userId, event.target.id === 'deductPoints' ? 'points' : 'item', countdownTimer, pointAmount, actualZollarAmount);
	}
  });
}

function handleDecision(userId, decision, countdownTimer, pointAmount, zollarAmount) {
  console.log(`Handling decision for user ${userId}: ${decision}`);
  clearInterval(countdownTimer);
  submitUserDecision(userId, decision, null, pointAmount, zollarAmount);
  removeDecisionModal();
}

function removeExistingTaxModal() {
  const existingModal = document.getElementById("taxDecisionModal");
  if (existingModal) {
	existingModal.remove();
  }
  localStorage.removeItem('taxDecisionState');
}

function removeDecisionModal() {
  console.log('Removing decision modal');
  const existingModal = document.getElementById("taxDecisionModal");
  if (existingModal) {
	existingModal.remove();
  }
  localStorage.removeItem('taxDecisionState');
  taxEventInProgress = false;
}

function enforceTaxDecision(userId, pointAmount, zollarAmount) {
  submitUserDecision(userId, "both", null, pointAmount, zollarAmount);
  removeDecisionModal();
}

function submitUserDecision(userId, decision, itemId, pointAmount, zollarAmount) {
  const sessionId = localStorage.getItem('sessionId');
  const decisionData = { userId, decision, itemId: itemId || undefined, sessionId, pointAmount, zollarAmount };
  fetch(`${apiBaseUrl}/api/boss/userDecision`, {
	method: 'POST',
	headers: {
	  'Content-Type': 'application/json',
	  'Authorization': `Bearer ${getAuthToken()}`
	},
	body: JSON.stringify(decisionData),
  })
  .then(async response => {
	if (!response.ok) {
	  throw new Error(`HTTP error! status: ${response.status}`);
	}
	const text = await response.text();
	try {
	  return JSON.parse(text);
	} catch (e) {
	  console.error("Could not parse JSON:", text);
	  throw e;
	}
  })
  .then(data => {
	console.log("Decision submitted:", data.message);
	showAlertTax(data.message);
  })
  .catch(error => console.error('Error submitting decision:', error));
}

// Function to show an alert after submitting the tax decision
function showAlertTax(message) {
	const alertOverlay = document.createElement('div');
	alertOverlay.style.position = 'fixed';
	alertOverlay.style.top = '0';
	alertOverlay.style.left = '0';
	alertOverlay.style.width = '100vw';
	alertOverlay.style.height = '100vh';
	alertOverlay.style.backgroundColor = 'rgba(0, 0, 0, 1)'; // Black background
	alertOverlay.style.display = 'flex';
	alertOverlay.style.alignItems = 'center';
	alertOverlay.style.justifyContent = 'center';
	alertOverlay.style.zIndex = '99999';

	const alertBox = document.createElement('div');
	alertBox.style.backgroundColor = '#000'; // Black background
	alertBox.style.padding = '20px 40px';
	alertBox.style.border = '2px solid #00ff00'; // Green border
	alertBox.style.borderRadius = '10px';
	alertBox.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
	alertBox.style.textAlign = 'center';
	alertBox.style.maxWidth = '80%'; // Adjust the max-width
	alertBox.style.color = '#00ff00'; // Green text
	alertBox.innerText = message;

	alertOverlay.appendChild(alertBox);
	document.body.appendChild(alertOverlay);

	setTimeout(() => {
		alertOverlay.remove();
	}, 3500);
}

let isNotificationDisplayed = false;
const userLocks = {};

function debounceAsync(func, delay) {
	let timeoutId;
	let isExecuting = false;
	let pendingArgs = null;

	const execute = async (args, resolve, reject) => {
		isExecuting = true;
		console.log('Executing function with args:', args);
		try {
			await func(...args);
			resolve();
		} catch (error) {
			reject(error);
		} finally {
			isExecuting = false;
			if (pendingArgs) {
				const nextArgs = pendingArgs;
				pendingArgs = null;
				execute(nextArgs.args, nextArgs.resolve, nextArgs.reject);
			}
		}
	};

	return (...args) => {
		return new Promise((resolve, reject) => {
			if (isExecuting) {
				pendingArgs = { args, resolve, reject };
				return;
			}

			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(() => {
				execute(args, resolve, reject);
			}, delay);
		});
	};
}

const assignQueue = debounceAsync(async function(userId) {
  if (userLocks[userId] || isNotificationDisplayed) return;

  userLocks[userId] = true;

  try {
	const response = await fetch(`${apiBaseUrl}/api/boss/assignNewItem`, {
	  method: 'POST',
	  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` }
	});

	if (!response.ok) {
	  const errorResponse = await response.json();
	  throw new Error(errorResponse.message || t('tax.assign_failed', 'Failed to assign new item to all portfolios.'));
	}

	displayNotification(t('tax.new_asset_assigned', 'Zederal Reserve has assigned a new asset to your portfolio.'));
  } catch (error) {
	console.error(`Error during commondity assignment process for user ${userId}:`, error);
  } finally {
	userLocks[userId] = false;
  }
}, 1000);

export const notifyUserOfNewItem = debounceAsync(async function() {
  if (isNotificationDisplayed) return;

  displayNotification(t('tax.new_asset_assigned', 'Zederal Reserve has assigned a new asset to your portfolio.'));
}, 1000);

let isItemIssued = false; 
let userItemIssued = {}; 
let userPointsIssued = {}; 

export const showtaxSingleItem = debounceAsync(async function(userId, portfolioIds) {
	if (userLocks[userId] || isNotificationDisplayed) {
		return;
	}

	if (!portfolioIds || portfolioIds.length === 0) {
		return;
	}

	userLocks[userId] = true;
	try {
		const response = await fetch(`${apiBaseUrl}/api/boss/taxSingleItem`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getAuthToken()}` },
			body: JSON.stringify({ portfolioIds })
		});

		if (!response.ok) {
			const errorResponse = await response.json();
			throw new Error(errorResponse.message || 'Failed to notify the backend.');
		}

		const responseData = await response.json();
		console.log('Tax single item response:', responseData);

		if (responseData.removedItems && responseData.removedItems.length > 0) {
		  displayNotification(t('tax.asset_taxed', 'You have been taxed an asset by the Zederal Reserve.'));
		  userItemIssued[userId] = false;
		  isItemIssued = false;
		} else {
		  displayNotification(t('tax.no_items_available', 'No non-traded items available for taxation.'));
		}
	} catch (error) {
		  console.error('Error during item taxing:', error);
		  displayNotification(t('tax.tax_item_failed', 'Failed to tax an item.'), false);
		} finally {
		  userLocks[userId] = false;
	}
}, 1000);


// Points deducted notification
export const showPointsDeductedNotification = debounceAsync(async function(portfolioIds, points, message) {
  if (!portfolioIds || portfolioIds.length === 0 || !points || isNaN(points) || points <= 0) return;

  const defaultMsg = `${t('tax.capital_taxed_prefix', 'You have been taxed capital by the Zederal Reserve!')} ${points} ${t('tax.points', 'capitaux')}`;
  displayNotification(message || defaultMsg);
}, 1000);

export const showItemSelectedAssign = debounceAsync(async function(portfolioIds, message) {
  if (!portfolioIds || portfolioIds.length === 0) return;

  displayNotification(message || t('tax.new_asset_received', 'You have received a new asset from the Zederal Reserve'));
}, 1000);

// Points assigned (refund) notification
export const showPointsAssignedNotification = debounceAsync(async function(portfolioIds, points) {
  if (!portfolioIds || portfolioIds.length === 0 || !points || isNaN(points) || points <= 0) return;

  const msg = `${t('tax.refund_received_prefix', 'You have received a refund of capital from the Zederal Reserve')} ${points} ${t('tax.points', 'Capital')}`;
  displayNotification(msg);
}, 1000);


// Zollar assign notification (keeps custom message if passed)
export const showZollarSelectedAssign = debounceAsync(async function (portfolioIds, message, amount) {
  if (!portfolioIds || portfolioIds.length === 0) return;

  const amt = Number(amount) > 0 ? Number(amount) : null;
  const fallback = amt
	? `${t('tax.zollar_assigned', 'You have received Zollars from the Zederal Reserve.')} (+${amt})`
	: t('tax.zollar_assigned', 'You have received Zollars from the Zederal Reserve.');
  displayNotification(message || fallback);
}, 1000);

export function displayNotification(message) {


	if (isNotificationDisplayed) return;

	isNotificationDisplayed = true;

	const overlay = document.createElement('div');
	overlay.style.position = 'fixed';
	overlay.style.top = '0';
	overlay.style.left = '0';
	overlay.style.width = '100vw';
	overlay.style.height = '100vh';
	overlay.style.backgroundColor = 'rgba(0, 0, 0, 1)';
	overlay.style.display = 'flex';
	overlay.style.alignItems = 'center';
	overlay.style.justifyContent = 'center';
	overlay.style.zIndex = '99999';

	const notification = document.createElement('div');
	notification.textContent = message;
	notification.style.backgroundColor = '#000';
	notification.style.padding = '20px 40px';
	notification.style.border = '2px solid #00ff00';
	notification.style.borderRadius = '10px';
	notification.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
	notification.style.textAlign = 'center';
	notification.style.maxWidth = '80%';
	notification.style.color = '#00ff00';

	overlay.appendChild(notification);
	document.body.appendChild(overlay);

	setTimeout(() => {
		overlay.remove();
		isNotificationDisplayed = false;
	}, 2000);
}
window.showtaxSingleItem = showtaxSingleItem;
window.showPointsDeductedNotification = showPointsDeductedNotification;
window.showItemSelectedAssign = showItemSelectedAssign;
window.showPointsAssignedNotification = showPointsAssignedNotification;
window.showZollarSelectedAssign = showZollarSelectedAssign;